export var HeaderFormTypes;
(function (HeaderFormTypes) {
    HeaderFormTypes["filter"] = "FilterType";
    HeaderFormTypes["add"] = "AddType";
    HeaderFormTypes["edit"] = "EditType";
})(HeaderFormTypes || (HeaderFormTypes = {}));
